/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface PinCompanyListRequest
 */
export interface PinCompanyListRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof PinCompanyListRequest
   */
  companyListIds?: Array<string>
}

export function PinCompanyListRequestFromJSON(json: any): PinCompanyListRequest {
  return PinCompanyListRequestFromJSONTyped(json, false)
}

export function PinCompanyListRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PinCompanyListRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    companyListIds: !exists(json, 'company_list_ids') ? undefined : json['company_list_ids']
  }
}

export function PinCompanyListRequestToJSON(value?: PinCompanyListRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    company_list_ids: value.companyListIds
  }
}
